export const getAdminPath = (payload = {}) => {
  const path = payload.path || "/shop";
  return path.startsWith("/") ? path : `/${path}`;
};

export const redirectToAdminApp = (payload = {}) => {
  window.location.assign(getAdminPath(payload));
};
